<template>
    <div v-if="rows.length != undefined && rows.length > 0 && rows.length != null">
        <div class="bg-white data-table p-0">
            <vue-good-table
                ref="listAssetTable"
                mode="remote"
                title="Assets"
                @on-page-change="onPageChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-sort-change="onSortChange"
                :totalRows="totalRecords"
                :columns="columns"
                :rows="rows"
                :pagination-options="{
                    enabled: true,
                    position: 'bottom',
                    perPage: perPage,
                    perPageDropdown:dropDownPerPage,
                    dropdownAllowAll: false,
                }"
                >
            </vue-good-table>
        </div>
    </div>
    <div v-else>
        <span>No data Found</span>
    </div>
</template>


<script>
import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);

import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
Vue.use(VueGoodTable);

import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

export default ({
    components: {
        appFooter: () => import('@/components/Footer'),
    },
    props: {
        fromModule: {
            type: Object,
            required: false,
            default: undefined
        },
    },
    watch:{
        
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        columns: [
            {
                label: 'RO #',
                field: 'work_order_no',
                filterable: false,
                hidden:false,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Group',
                field: 'group',
                filterable: false,
                hidden:false,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Unit #',
                field: 'unit',
                filterable: false,
                hidden:false,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Invoice Date',
                field: 'invoice_date',
                filterable: false,
                hidden:true,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Created Date',
                field: 'created_date',
                filterable: false,
                hidden:true,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Started Date',
                field: 'started_date',
                filterable: false,
                hidden:true,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Expected Finish',
                field: 'expected_finish',
                filterable: false,
                hidden:false,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Finished Date',
                field: 'finished_date',
                filterable: false,
                hidden:true,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Status',
                field: 'status',
                filterable: false,
                hidden:false,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Total Amount',
                field: 'total_amount',
                filterable: false,
                hidden:false,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Dwell Time',
                field: 'dwell_time',
                filterable: false,
                hidden:true,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Cycle Time',
                field: 'cycle_time',
                filterable: false,
                hidden:true,
                fpFieldType:"text",
                sortable:false,
            },
            {
                label: 'Deviation Time',
                field: 'deviation_time',
                filterable: false,
                hidden:true,
                fpFieldType:"text",
                sortable:false,
            },
        ],
        rows: [],
        totalRecords: 0,
        serverParams: {
            columnFilters: {},
            sort: {
                field: 'id',
                type: 'desc',
            },
            page: 1,
            perPage: 50
        },
        reportData:null,
        reportType:'',
    }),
    mounted: function() {
        let self = this;
        setTimeout(function () {
            self.getlistdata();
        }, 1000);
    },
    methods: {
        updateParams(newProps) { 
            if(newProps.columnFilters != undefined && newProps.columnFilters != null) {
                this.serverParams.columnFilters = newProps.columnFilters;
            }
            if(newProps.sort != undefined && newProps.sort != null) {
                this.serverParams.sort = newProps.sort;
            }
            if(newProps.page != undefined && newProps.page != null) {
                this.serverParams.page = newProps.page;
            }
            if(newProps.perPage != undefined && newProps.perPage != null) {
                this.serverParams.perPage = newProps.perPage;
            }
            if(newProps.selectedAll != undefined && newProps.selectedAll != null) {
                this.serverParams.selectedAll = newProps.selectedAll;
            }
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            if (this.firstLoad == 1){
                this.getlistdata();
            }
        },
        onPerPageChange(params) {
            let self = this;
            this.updateParams({perPage: params.currentPerPage});
            this.totalRecords = self.totalRecords;

            if( self.totalRecords < (params.currentPerPage * this.serverParams.page) ) {
                this.updateParams({page: 1});
            } else {

                this.updateParams({page: params.currentPage});
            }
            if (this.firstLoad == 1){
                this.getlistdata();
            }
        },
        onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
            this.getlistdata();
        },
        getlistdata(){
            let self = this;
            let selectedRows = [];
            let filterAll = self.serverParams.columnFilters;
            self.$parent.loading = true;

            if(self.fromModule!=null && self.fromModule!=undefined){
                self.reportData = self.fromModule;
                self.reportType = self.reportData.report_type.value;
            }
            let fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: filterAll,
                sort: self.serverParams.sort,
                flag: self.flag,
                action:self.action,
                selectedRows:selectedRows,
                report_data:JSON.stringify(self.reportData),
            };
            self.firstLoad = 1;

            $.ajax({
                url: process.env.ROOT_API + "/repair-orders-analytics/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;

                        let i = 0;
                        //show or hide columns
                        for (let val of self.columns) {
                            if(self.reportType == 'Invoiced ROs'){
                                if(val.field == 'invoice_date'){
                                    self.$set(self.columns[i], 'hidden', false);
                                } else if(val.field == 'expected_finish'){
                                    self.$set(self.columns[i], 'hidden', true);
                                }
                            } else if(self.reportType == 'Expected ROs'){
                                if(val.field == 'invoice_date'){
                                    self.$set(self.columns[i], 'hidden', true);
                                }
                            } else if(self.reportType == 'Cycle Time'){
                                if(val.field == 'unit' || val.field == 'group' || val.field == 'total_amount'){
                                    self.$set(self.columns[i], 'hidden', true);
                                } else if(val.field == 'started_date' || val.field == 'expected_finish' || val.field == 'finished_date' || val.field == 'cycle_time'){
                                    self.$set(self.columns[i], 'hidden', false);
                                }
                            } else if(self.reportType == 'Expected vs Actual Finish Time'){
                                if(val.field == 'unit' || val.field == 'group' || val.field == 'total_amount'){
                                    self.$set(self.columns[i], 'hidden', true);
                                } else if(val.field == 'started_date' || val.field == 'expected_finish' || val.field == 'finished_date' || val.field == 'deviation_time'){
                                    self.$set(self.columns[i], 'hidden', false);
                                }
                            } else if(self.reportType == 'Dwell Time'){
                                if(val.field == 'group' || val.field == 'expected_finish' || val.field == 'total_amount'){
                                    self.$set(self.columns[i], 'hidden', true);
                                } else if(val.field == 'created_date' || val.field == 'started_date' || val.field == 'dwell_time'){
                                    self.$set(self.columns[i], 'hidden', false);
                                }
                            }
                            i++;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'get-asset-list')
                }
            });
            
        },
    }
    
})
</script>



// WEBPACK FOOTER //
// src/components/dashboard/RepairOrderList.vue